import React, { createContext, useContext, useCallback, useState, useEffect } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

const DrawerStateContext = createContext();

export const DrawerStateProvider = ({ children }) => {
  const drawerState = useState({
    userIntent: null,
    pageIntent: true,
    hide: false
  });

  return (
    <DrawerStateContext.Provider value={drawerState}>
      {children}
    </DrawerStateContext.Provider>
  );
};

export const useSetDrawerState = ({ userIntent } = { userIntent: false }) => {
  const [previousState, setState] = useContext(DrawerStateContext);
  const intentKey = userIntent ? 'userIntent' : 'pageIntent';
  const setValueForIntent = useCallback(
    value => {
      setState({ ...previousState, [intentKey]: value });
    },
    [intentKey, previousState, setState]
  );

  return setValueForIntent;
};

export const useHideDrawer = () => {
  const [, setState] = useContext(DrawerStateContext);
  const hideDrawer = useCallback(() => {
    setState(state => ({ ...state, hide: true }));
  }, [setState]);

  useEffect(() => {
    hideDrawer();
  }, []);
};

export const useGetDrawerState = () => {
  const mediumAndUp = useMediaQuery(theme => theme.breakpoints.up('md'));

  const [{ userIntent, pageIntent }] = useContext(DrawerStateContext);

  // If set, userIntent overrides any other value; this should always be first
  if (userIntent !== null) {
    return userIntent;
  }

  // If below medium breakpoint, always return false; otherwise return pageIntent
  return !mediumAndUp ? false : pageIntent;
};

export const useGetIsDrawerHidden = () => {
  const [{ hide }] = useContext(DrawerStateContext);

  return hide;
};
